module.exports = __webpack_public_path__ + "static/media/code-icon.4b1d12fc.svg";